import {Injectable} from '@angular/core';
import {ProductParameterSizeState, Store as ProductParameterSizeStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {ProductParameterSize} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {ProductParameterSizeQuery} from './query';

@Injectable({ providedIn: 'root' })
export class ProductParameterSizeService extends EntityService<ProductParameterSizeStore, ProductParameterSizeState> {

  productParameterSizes$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new ProductParameterSize(item)).sort((u1, u2) => u1.toString() > u2.toString() ? 1 : -1)),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('productParameterSize.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('productParameterSize.name'),
        inputType: 'text',
        name: 'name',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: ProductParameterSizeQuery,
    protected store: ProductParameterSizeStore) {
    super(store, ProductParameterSize);
  }

  get resourceName(): string {
    return 'products/product-parameter-size';
  }

}
